<template>
    <div class="collateral-build-select-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Choose Collateral Build</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <collateral-build-display
                    multiselector
                    primary
                    :initialSelectedItems="initialSelectedItems"
                    :hasCardOptions="false"
                    @select="select" />
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-btn" @click="closeWidget">
                        Cancel
                    </app-button>
                </div>
                <div class="action-container">
                    <app-button @click="confirmBuilds()">Choose these builds</app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
const CollateralBuildDisplay = () => import('@/components/collateral/collateral-build-display');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'collateral-build-select-widget',

    props: {
        widget: {
            type: Object,
            required: true
        }
    },

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'collateral-build-display': CollateralBuildDisplay
    },

    data() {
        return {
            allowMultipleSelections: this.widget.allowMultipleSelections || false,
            selectedItems: [],
            initialSelectedItems: []
        };
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        select(items) {
            this.selectedItems = items;
        },

        confirmBuilds() {
            EventBus.$emit('collateral-build:select', this.selectedItems.map(item => item.id));
            this.closeWidget();
        }
    },

    created() {
        if (this.widget.initialSelectedIds) {
            this.initialSelectedItems = this.widget.initialSelectedIds.map(id => { 
                return { id: id };
            });
        }
    }
}
</script>

<style>
.collateral-build-select-widget .content-wrapper {
    padding: 0 35px;
}

.collateral-build-select-widget .master-display .master-cards .master-card-wrapper {
    padding: 0;
}

.collateral-build-select-widget .master-display .display-title {
    display: none;
}

.collateral-build-select-widget .app-multiselect-new.multiselect .multiselect__tags {
    background: transparent;
    padding-left: 6px;
}

.collateral-build-select-widget .cancel-btn {
    background: transparent;
    color: #877D88;
    border: none;
}

.collateral-build-select-widget .cancel-btn:hover {
    background: #E1E0E5;
}

.collateral-build-select-widget .email-template-display .master-card .title-row {
    padding-top: 10px;
}

.collateral-build-select-widget .master-card {
    margin: 0 5px;
}

.collateral-build-select-widget .email-template-display .template-title {
    max-width: 240px;
}

.collateral-build-select-widget .widget-contents-container .content-wrapper {
    padding-top: 0;
}

.collateral-build-select-widget .content-wrapper .master-card-controls .custom-filter-container {
    right: -290px;
    width: 560px;
}
</style>